import React, { useEffect, useState } from "react";
import SelectSigners from "../components/shared/fields/SelectSigners";
import AddContact from "./AddContact";
import ModalUi from "./ModalUi";
import { useTranslation } from "react-i18next";
import Parse from "parse";

const LinkUserModal = (props) => {
  const { t } = useTranslation();
  const [isContactbookEnabled, setIsContactbookEnabled] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("enableContactbook");
    if (stored !== null) {
      setIsContactbookEnabled(stored === "true");
    }

    const fetchSetting = async () => {
      try {
        const result = await Parse.Cloud.run("getgeneralsettings");
        const enabled =
          result?.enableContactbook !== undefined
            ? result.enableContactbook
            : true;
        setIsContactbookEnabled(enabled);
        localStorage.setItem("enableContactbook", enabled ? "true" : "false");
      } catch (error) {
        console.log("err", error);
      }
    };

    fetchSetting();
  }, []);
  return (
    <ModalUi
      title={t("add/choose-signer")}
      isOpen={
        props?.isAddSigner ||
        (props?.isAddUser && props?.isAddUser[props?.uniqueId])
      }
      handleClose={props.closePopup}
    >
      {isContactbookEnabled && (
        <>
          <SelectSigners
            details={props.handleAddUser}
            closePopup={props.closePopup}
            signersData={props?.signersData}
            jwttoken={props?.jwttoken}
          />
          <div className="op-divider text-base-content mx-[25%] my-1">
            {t("or")}
          </div>
        </>
      )}
      <AddContact
        details={props.handleAddUser}
        closePopup={props.closePopup}
        jwttoken={props?.jwttoken}
      />
    </ModalUi>
  );
};

export default LinkUserModal;
